export const SHOWS = [
    {
        slug: "jibon-o-jibika",
        title: "Jibon O Jibika",
        category: "Lifestyle",
        days: "Everyday",
        time: "7:00 AM",
        img: "/assets/shows/jibon-o-jibika.jpg",
        desc: "An informative agricultural programme on farming, cultivation and rural livelihoods — modern farming techniques, crop production and answers to everyday challenges, promoting sustainable agriculture and stronger rural communities.",
    },
    {
        slug: "gane-gane-matir-tane",
        title: "Gane Gane Matir Tane",
        category: "Music & Culture",
        days: "Everyday",
        time: "7:30 AM",
        img: "/assets/shows/ggmt-photo.jpg",
        poster: "/assets/shows/gane-gane-matir-tane.jpg",
        desc: "A musical celebration of Bengal's rich heritage — soulful songs, folk melodies and performances rooted in the soil of Bengal, connecting viewers with rural life, traditions and emotions.",
    },
    {
        slug: "rong-beronger-golpo",
        title: "Rong Beronger Golpo",
        category: "Children's Shows",
        days: "Monday – Friday",
        time: "11:30 AM",
        img: "/assets/shows/rong-beronger-golpo.jpg",
        desc: "A collection of wonder tales from Bengal and across the globe — fairies, kings & queens, dwarfs & dragons, talking animals, giants and witches. Stories of magic, myth and folklore.",
    },
    {
        slug: "magojastra",
        title: "Magojastra",
        category: "Children's Shows",
        days: "Monday – Friday",
        time: "12:00 PM",
        img: "/assets/shows/magojastra.png",
        desc: "An exciting detective adventure series featuring four curious kids and their clever uncle. Together they solve mysterious cases, uncover hidden clues and turn every mystery into an exciting learning experience.",
    },
    {
        slug: "liliput",
        title: "Liliput",
        category: "Children's Shows",
        days: "Monday – Friday",
        time: "12:30 PM",
        img: "/assets/shows/liliput.jpg",
        desc: "The story of a tiny alien stranded at Fulmani School who befriends Kuttus, Poltu & Rani. Small in size but big on power — he turns invisible, punishes the wicked and flies to the rescue. Ice is his only fuel!",
    },
    {
        slug: "midday-movies",
        title: "Mid Day Movies",
        category: "Movies",
        days: "Everyday",
        time: "1:00 PM",
        img: "/assets/shows/midday-movies.jpg",
        desc: "A curated selection of popular Bengali films every afternoon — engaging stories, memorable performances, music, drama, comedy and emotion. The richness of Bengali cinema from your living room.",
    },
    {
        slug: "its-show-time",
        title: "It's Show Time",
        category: "Entertainment",
        days: "Monday – Friday",
        time: "5:30 PM",
        img: "/assets/shows/its-show-time.jpg",
        desc: "The latest from the world of cinema and television — popular movies, stars, celebrity moments, upcoming releases, interviews and fascinating stories from the glamorous world of showbiz.",
    },
    {
        slug: "praner-kirtan",
        title: "Praner Kirtan",
        category: "Music & Culture",
        days: "Everyday",
        time: "6:00 PM",
        img: "/assets/shows/praner-kirtan.jpg",
        desc: "A devotional programme celebrating the rich tradition of Bengali kirtan — soulful performances and spiritual songs that create a peaceful, uplifting evening atmosphere.",
    },
    {
        slug: "khude-rannabati",
        title: "Khude Rannabati",
        category: "Entertainment",
        days: "Monday – Friday",
        time: "7:00 PM",
        img: "/assets/shows/krb-photo.jpg",
        poster: "/assets/shows/khude-rannabati.jpg",
        desc: "Bengal's cutest kids' cookery show — easy, quick and tasty recipes that keep little hands and brains busy, and a handy guide for mothers to delight kids with innovative dishes.",
    },
    {
        slug: "10-e-hazar",
        title: "10-e Hazar",
        category: "Entertainment",
        days: "Monday – Friday",
        time: "7:30 PM",
        img: "/assets/shows/10-e-hazar.jpg",
        desc: "A thrilling prime-time quiz of knowledge, quick thinking, brain teasers and puzzles. Contestants battle questions from every field on their way to the grand prize — lively viewing for all ages.",
    },
    {
        slug: "lullu-bhuter-goppo",
        title: "Lullu Bhuter Goppo",
        category: "Children's Shows",
        days: "Saturday – Sunday",
        time: "11:30 AM",
        img: "/assets/shows/lullu-bhuter-goppo.jpg",
        desc: "Lullu is a civilized, noble young ghost who longs for human life. Disliked by ghosts for befriending humans and kept at bay by people for being a ghost, he helps everyone he meets to earn his way back.",
    },
    {
        slug: "on-air-stories",
        title: "On Air Stories",
        category: "Entertainment",
        days: "Saturday – Sunday",
        time: "9:00 PM",
        img: "/assets/shows/on-air-stories.jpg",
        desc: "A podcast-style programme of interesting stories, conversations and experiences — thoughtful narration and captivating discussions that connect audiences with ideas through the power of voice.",
    },
];

export const SHOWS_BY_SLUG = Object.fromEntries(SHOWS.map((s) => [s.slug, s]));

export const CATEGORIES = ["All", "Lifestyle", "Music & Culture", "Children's Shows", "Entertainment", "Movies"];

export const MOST_WATCHED = ["khude-rannabati", "gane-gane-matir-tane", "its-show-time", "midday-movies"];

export const WEEKDAY_SLOTS = [
    { t: "7:00 AM", m: 420, show: "jibon-o-jibika" },
    { t: "7:30 AM", m: 450, show: "gane-gane-matir-tane" },
    { t: "11:30 AM", m: 690, show: "rong-beronger-golpo" },
    { t: "12:00 PM", m: 720, show: "magojastra" },
    { t: "12:30 PM", m: 750, show: "liliput" },
    { t: "1:00 PM", m: 780, show: "midday-movies" },
    { t: "5:30 PM", m: 1050, show: "its-show-time" },
    { t: "6:00 PM", m: 1080, show: "praner-kirtan" },
    { t: "7:00 PM", m: 1140, show: "khude-rannabati" },
    { t: "7:30 PM", m: 1170, show: "10-e-hazar" },
];

export const WEEKEND_SLOTS = [
    { t: "7:00 AM", m: 420, show: "jibon-o-jibika" },
    { t: "7:30 AM", m: 450, show: "gane-gane-matir-tane" },
    { t: "11:30 AM", m: 690, show: "lullu-bhuter-goppo" },
    { t: "1:00 PM", m: 780, show: "midday-movies" },
    { t: "6:00 PM", m: 1080, show: "praner-kirtan" },
    { t: "9:00 PM", m: 1260, show: "on-air-stories" },
];

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function isWeekend(d = new Date()) {
    const day = d.getDay();
    return day === 0 || day === 6;
}

export function getNowAiring(now = new Date()) {
    const slots = isWeekend(now) ? WEEKEND_SLOTS : WEEKDAY_SLOTS;
    const mins = now.getHours() * 60 + now.getMinutes();
    let idx = -1;
    slots.forEach((s, i) => {
        if (mins >= s.m) idx = i;
    });
    if (idx < 0) return { current: null, next: slots[0], progress: 0 };
    const slot = slots[idx];
    const next = slots[idx + 1] || null;
    const dur = (next ? next.m : slot.m + 90) - slot.m;
    return {
        current: slot,
        next,
        progress: Math.min(1, Math.max(0, (mins - slot.m) / dur)),
    };
}

function fmtTime(abs) {
    const m = ((abs % 1440) + 1440) % 1440;
    const h24 = Math.floor(m / 60);
    const h = ((h24 + 11) % 12) + 1;
    return `${h}:${String(m % 60).padStart(2, "0")} ${h24 < 12 ? "AM" : "PM"}`;
}

export function getShowStatus(slug, now = new Date()) {
    const occurrences = [
        ...WEEKDAY_SLOTS.map((s) => ({ m: s.m, wknd: false, show: s.show })),
        ...WEEKEND_SLOTS.map((s) => ({ m: s.m, wknd: true, show: s.show })),
    ].filter((s) => s.show === slug);
    if (!occurrences.length) return null;
    const nowAbs = now.getDay() * 1440 + now.getHours() * 60 + now.getMinutes();
    let prev = null;
    let next = null;
    for (let w = -1; w <= 1; w++) {
        for (let d = 0; d < 7; d++) {
            const wknd = d === 0 || d === 6;
            for (const s of occurrences) {
                if (s.wknd !== wknd) continue;
                const abs = (w * 7 + d) * 1440 + s.m;
                if (abs <= nowAbs && (prev === null || abs > prev.abs)) prev = { abs, d };
                if (abs > nowAbs && (next === null || abs < next.abs)) next = { abs, d };
            }
        }
    }
    if (prev && nowAbs - prev.abs < 60) return { type: "live", label: "On Air Now" };
    if (prev && nowAbs - prev.abs < 24 * 60) {
        const diff = nowAbs - prev.abs;
        const h = Math.floor(diff / 60);
        const mm = diff % 60;
        return { type: "aired", label: h > 0 ? `Aired ${h}h${mm ? ` ${mm}m` : ""} ago` : `Aired ${mm}m ago` };
    }
    if (next) {
        const diffDays = Math.floor(next.abs / 1440) - now.getDay();
        const when =
            diffDays === 0
                ? `Today ${fmtTime(next.abs)}`
                : diffDays === 1
                  ? `Tomorrow ${fmtTime(next.abs)}`
                  : `${DAY_NAMES[next.d % 7]} ${fmtTime(next.abs)}`;
        return { type: "upcoming", label: `Upcoming · ${when}` };
    }
    return null;
}

export const DTH_OPERATORS = [
    { name: "Tata Play", lcn: "1355" },
    { name: "SUN Direct", lcn: "639" },
    { name: "Hathway", lcn: "692" },
    { name: "SITI", lcn: "257" },
];

export const CABLE_OPERATORS = [
    ["GTPL KCBPL", "14"], ["Metro Cast", "178/8"], ["MRMPL", "275"], ["Meghbela", "91"],
    ["CCN", "220"], ["Arohan", "9"], ["TJ Cable", "27"], ["ADPL", "48"],
    ["ASCSC", "12"], ["ABSK Digital", "14"], ["Bhorer Alo", "664"], ["BRT Digital", "15"],
    ["Haur Cable", "420"], ["Debjani Cable", "261"], ["Sampriti Cable", "13"], ["Alok Bindu", "6"],
    ["Choudhury Cable", "15"], ["Sri Durga", "288"], ["Third Eye Digital", "10"], ["Sony Cable", "420"],
    ["Udayan Digital", "14"], ["Pan Metro", "118"], ["Barghabhima", "9"], ["Binodan", "415"],
    ["SS Cable", "18"], ["Uttrer Darpan", "112"], ["Velocity", "38"], ["Ashok Network", "10"],
    ["Swastika", "170"], ["Star Vision", "615"], ["NXT Digital", "7"],
];

export const NAV_LINKS = [
    { to: "/", label: "Home", testId: "nav-link-home" },
    { to: "/about", label: "About Us", testId: "nav-link-about" },
    { to: "/shows", label: "Shows & Programming", testId: "nav-link-shows" },
    { to: "/schedule", label: "Schedule", testId: "nav-link-schedule" },
    { to: "/advertise", label: "Advertise With Us", testId: "nav-link-advertise" },
    { to: "/contact", label: "Contact Us", testId: "nav-link-contact" },
];

export const SOCIALS = [
    { name: "Facebook", url: "https://www.facebook.com/Rongeentvofficial", icon: "facebook" },
    { name: "Twitter / X", url: "https://twitter.com/RongeenTv", icon: "twitter" },
    { name: "YouTube", url: "https://www.youtube.com/channel/UC_2Sqxu6sBhm7nyj2gniiQw", icon: "youtube" },
    { name: "Instagram", url: "https://www.instagram.com/rongeentvofficial", icon: "instagram" },
];

export const CONTACT = {
    address: [
        "Biswas Media Solutions Pvt Ltd",
        "Curiocity Realtech, Chakpachuria",
        "Mahammadpur, New Town",
        "Kolkata — 700135, West Bengal, India",
    ],
    phone: "033 2591 0007 / 08",
    phoneHref: "+913325910007",
    whatsapp: "+91 90072 12345",
    whatsappHref: "https://wa.me/919007212345",
    email: "info@rongeentv.com",
    hours: "Monday – Saturday, 10:00 AM – 6:00 PM IST",
};
